

export const notificationsConstants = {
    PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',
    POP_NOTIFICATION : 'POP_NOTIFICATION'
};
